const titleList = {
    Benchmark_Index:'Benchmark Index',
    Inception_Date:'Inception Date',
    TICKER:'TICKER',
    ISIN:'ISIN',
    CUSIP:'CUSIP',
    Bloomberg:'Bloomberg',
    OTC:'OTC',
    Investment_Objective:'Investment Objective',
    Investor_Qualification:'Investor Qualification',
    Subscription_Unit_Size:'Subscription Unit Size',
    Subscription_Cap:'Subscription Cap',
    Minimum_Subscription_Amount:'Minimum Subscription Amount',
    Minimum_Redemption_Amount:'Minimum Redemption Amount',
    Subscription_Hours:'Subscription Hours',
    Redemption_Hours:'Redemption Hours',
    Fee:'Fee',
    Price_Quotation:'Price Quotation',
    Settlement_Method:'Settlement Method',
    Subscription_Cut_off_Time:'Subscription Cut-off Time',
    Redemption_Cut_off_Time:'Redemption Cut-off Time',
    Subscription_Fee:'Subscription Fee ( % )',
    Redemption_Fee:'Redemption Fee ( % )',
    Maintenance_Fee:'Maintenance Fee ( % )',
    Daily_Settlement_Time:'Daily Settlement Time',
    Distributor_Fee:'Distributor Fee ( % )',
    Minimum_Amount:'Minimum Amount ( USD )',
    Cashback_rate:'Cashback rate ( % )',
    Promotion_Start_Date:'Promotion Start Date',
    Promotion_End_Date:'Promotion End Date',
    Qualification_Period:'Qualification Period'
}

export default{
    titleList
}


// WEBPACK FOOTER //
// ./src/utils/miniBTC.js